export const knowledgeSourceDefinitions = "/:app_group_id/knowledge_source/definitions";
